export default __webpack_public_path__ + "f87a9cc5070159f0d1c13d7d16adaebc.png";